export * from "ce/api/DrawDBApi";
import { default as CE_DrawDBApi } from "ce/api/DrawDBApi";

class DrawDBApi extends CE_DrawDBApi {}

export default DrawDBApi;
